export function getSuffix(fileName) {
    if (!fileName) {
        return;
    }
    fileName = fileName.split('?')[0];
    var index = fileName.lastIndexOf('.');
    var suffix = fileName.substr(index + 1);
    return suffix;
};

export function getFileType(fileName) {
    if (!fileName) {
        return;
    }
    fileName = fileName.split('?')[0];
    var index = fileName.lastIndexOf('.');
    var suffix = fileName.substr(index + 1);
    suffix = suffix.toUpperCase();
    var type = fileType[suffix];
    if (!type) {
        return 'link';
    }
    return type;
};

var fileType = {
    'PPT': 'ppt',
    'PPTX': 'ppt',
    'DOC': 'doc',
    'DOCX': 'doc',
    'PDF': 'pdf',
    'PNG': 'pic',
    'JPEG': 'pic',
    'JPG': 'pic',
    'BMP': 'pic',
    'GIF': 'pic',
    'WMV': 'video',
    'AVI': 'video',
    'RM': 'video',
    'RMVB': 'video',
    'DAT': 'video',
    'ASF': 'video',
    'RAM': 'video',
    'MPG': 'video',
    'MPEG': 'video',
    '3GP': 'video',
    'MOV': 'video',
    'MP4': 'video',
    'M4V': 'video',
    'F4V': 'video',
    'DVIX': 'video',
    'DV': 'video',
    'MKV': 'video',
    'FLV': 'video',
    'QT': 'video',
    'CPK': 'video',
    'VOB': 'video',
    'MP3': 'audio',
    'WAV': 'audio',
	'M4A': 'audio',
    'TXT': 'text',
    'XLSX': 'excel',
    'XLSM': 'excel',
    'XLTX': 'excel',
    'XLTM': 'excel',
    'XLS': 'excel'
};


var courseColorMap = {
    1: ['#B54A35', '#953017'],
    2: ['#5C97F3', '#4E80C8'],
    3: ['#D2943B', '#A27116'],
    4: ['#3FB963', '#189940'],
    5: ['#8E537D', '#683159'],
    6: ['#06A1AD', '#188D92'],
    7: ['#617898', '#6E829C'],
    8: ['#E07191', '#BD4E5F']
}


export function getColorList(color) {
    if (!color || color < 1 || color > 8) {
        return ['#fff', '#fff'];
    }
    return courseColorMap[color];
};

export function getThumbnail(src) {
    return src + '?x-oss-process=image/resize,m_mfit,w_320';
};



export function getDate(timeLong) {
    if (!timeLong) {
        return "";
    }
    var fmt = "yyyy-MM-dd";
    var data = new Date(timeLong);
    return dataFormat(fmt, data);
}


export function getNowFormatDate(date) {
    console.log(date);
    var seperator1 = "-";
    var seperator2 = ":";
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    var minutes = date.getMinutes();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
    }
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
        " " + date.getHours() + seperator2 + minutes;
    console.log(currentdate);
    return currentdate;
}

export function stringToDate(dateStr, separator1) {
    if (!separator1) {
        separator1 = "-";
    }
    var dateArr = dateStr.split(separator1);
    var year = parseInt(dateArr[0]);
    var month;
    //处理月份为04这样的情况
    if (dateArr[1].indexOf("0") == 0) {
        month = parseInt(dateArr[1].substring(1));
    } else {
        month = parseInt(dateArr[1]);
    }
    var day = parseInt(dateArr[2]);
    var date = new Date(year, month - 1, day);
    return date;
}

export function getTimeFormatDate(timeLong) {
    if (!timeLong) {
        return "";
    }
    var fmt = "yyyy-MM-dd hh:mm";
    var data = new Date(timeLong);
    return dataFormat(fmt, data);
}

export function getTimeFormatDateWithFormat(timeLong,format) {
	if (!timeLong) {
		return "";
	}
	var fmt = format;
	var data = new Date(timeLong);
	return dataFormat(fmt, data);
}

//相减的时间戳转时分秒
export function stampToDate(stamp, fmthours, fmtMin, fmtSec) {
    let hours = parseInt((stamp % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = parseInt((stamp % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = parseInt((stamp % (1000 * 60)) / 1000);
    if (fmthours) {
        hours = hours < 10 ? ('0' + hours) : hours;
    }
    if (fmtMin) {
        minutes = minutes < 10 ? ('0' + minutes) : minutes;
    }
    if (fmtSec) {
        seconds = seconds < 10 && seconds >= 1 ? ('0' + seconds) : seconds;
    }
    return hours + '时' + minutes +'分' + seconds + '秒';
}

// 时间格式化
export function dataFormat(fmt, date) {
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

/**
 *
 * 弹窗封装
 *
 */
export function dialog(options) {
    var html = options.html;
    var cancelCallBack = options.cancelCallBack;
    var confirmCallBack = options.confirmCallBack;
    var arr = options.arr;
    arr = arr || ['删除', '取消', '否', '是'];
    console.log(arr);
    var buttons = [];
    for(let i = 1;i < arr.length;i++){
        var obj = {
            label: arr[i],
            type: 'default',
            onClick: function() {
                cancelCallBack && cancelCallBack();
            }
        }
        if( i + 1 == arr.length){
            obj = {
                label: arr[i],
                type: 'primary',
                onClick: function() {
                    confirmCallBack && confirmCallBack();
                }
            }
        }
        buttons.push(obj);
        console.log(buttons);
    }
    return weui.confirm(html, {
        className: 's-k-weui-dlg',
        title: arr[0],
        buttons: buttons
    });
}


//文件路径根据不同的类型转换图片路径
export function getFileUrl(src) {
    let type = src.split(".").pop();
    type = type ? type.toLowerCase() : "";
    let imgUrl = '../../../../static/images/file_icon/';
    if (type == 'ppt' || type == 'pptx') {
        return imgUrl + 'ppt.png';
    } else if (type == 'pdf') {
        return imgUrl + 'pdf.png';
    } else if (type == 'doc' || type == 'docx') {
        return imgUrl + 'word.png';
    } else if (type == 'mp3' || type == 'wav') {
        return imgUrl + 'audio.png';
    } else if (type == 'txt') {
        return imgUrl + 'txt.png';
    } else if (type == 'xlsx' || type == 'xlsm' || type == 'xltx' || type == 'xltm' || type == 'xls') {
        return imgUrl + 'excel.png';
    } else {
        return src;
    }
}

export function changeFileType(src) {
    let type = src.split(".").pop();
    if (type == 'ppt' || type == 'pptx') {
        return 1;
    } else if (type == 'pdf') {
        return 2;
    } else if (type == 'jpg' || type == 'png' || type == 'jpeg') {
        return 3;
    } else if (type == 'doc' || type == 'docx') {
        return 4;
    } else if (type == 'mp3' || type == 'wav') {
        return 5;
    } else if (type == 'txt') {
        return 6;
    } else if (type == 'xlsx' || type == 'xlsm' || type == 'xltx' || type == 'xltm' || type == 'xls') {
        return 7;
    } else {
        return '';
    }
}

// 获取中文数字（100以内）
export function getChineseNum(num) {
    let chineseNumArr = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
    if (num <= 10) { // 小于等于10
        return chineseNumArr[num];
    }
    if (chineseNumArr[num / 10]) { // 10的倍数
        return chineseNumArr[num / 10] + "十";
    }
    var arr = String(num).split(""); // 介于10~20 20~30 。。。。
    if (arr[0] == 1) {
        return "十" + chineseNumArr[arr[1]];
    }
    return chineseNumArr[arr[0]] + "十" + chineseNumArr[arr[1]];
}

export function inputBlurFix() {
    $('textarea').on('blur', function() {
        window.scrollTo(0, 0);
    })
}

var initSDK = function(){

}

export function initWXSDK(_this, callback){
    var appId = _this.appId; // "wx36387094b6ed22b5";//
    var signatureLink = _this.apiUrl + '/service/getSignature';
    var timestamp = "1414587499";
    var nonceStr = "xkXGEs8VMCP";
    var signature = '';
    var u = navigator.userAgent;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    var url = window.location.href;
    if(isIOS){
        url = window.location.href.split('#')[0];
    }

    $.ajax({
        url: signatureLink,
        async: false,
        data: {
            url: url
        },
        success: function (data) {
            signature = data;
        }
    });

    wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名
        jsApiList: ['startRecord', 'stopRecord', 'playVoice', 'pauseVoice', 'stopVoice', 'uploadVoice', 'downloadVoice', 'scanQRCode', 'chooseImage', 'getLocalImgData', 'updateAppMessageShareData', 'updateTimelineShareData']
        //scanQRCode
    });

    wx.ready(function () {
        if(callback){
            callback();
        }
    });

    wx.error(function (res) {
        if(callback){
            callback();
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./static/js/util.js
// module id = VqYF
// module chunks = 82